export const enConfig: Partial<InitOptions> = {
  businessName: 'Live Support',
  locale: 'en',
};
